import React from 'react'
import Layout from '../Layout'
import OutComeContainer from '../../../Components/OutComeContainer/OutComeContainer'

const OutCome = () => {
  return (
    <Layout><OutComeContainer/></Layout>
  )
}

export default OutCome